var _g, _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAngryFace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_468_2660)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    width: 26,
    height: 25,
    rx: 6.25415,
    fill: "#FF5F3D",
    fillOpacity: 0.9,
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4995 7.95464C13.4044 7.95464 13.3199 7.92294 13.2459 7.85955C12.4747 7.14109 11.4709 6.73959 10.4144 6.73959C9.37892 6.73959 8.38575 7.13052 7.61446 7.82785C7.46654 7.96521 7.23409 7.95464 7.09674 7.80672C6.95939 7.6588 6.96995 7.42636 7.11787 7.28901C8.01595 6.46489 9.18874 6 10.4144 6C11.6611 6 12.8444 6.46489 13.7531 7.32071C13.901 7.45806 13.9116 7.69051 13.7742 7.83842C13.7003 7.92295 13.5946 7.95464 13.4995 7.95464Z",
    fill: "#060000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0005 7.95464C17.9054 7.95464 17.7997 7.91238 17.7258 7.83842C17.5884 7.69051 17.5884 7.45806 17.7469 7.32071C18.6555 6.46489 19.8389 6 21.0856 6C22.3112 6 23.484 6.45432 24.3821 7.28901C24.53 7.42636 24.5406 7.6588 24.4032 7.80672C24.2659 7.95464 24.0334 7.96521 23.8855 7.82785C23.1248 7.13052 22.1316 6.73959 21.0856 6.73959C20.0291 6.73959 19.0253 7.14109 18.254 7.85955C18.1801 7.92294 18.0956 7.95464 18.0005 7.95464Z",
    fill: "#060000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0955 19.0542C17.9687 19.0542 17.8525 18.9908 17.7785 18.8851C17.3348 18.1878 16.5741 17.7652 15.7499 17.7652C14.9258 17.7652 14.1651 18.1772 13.7213 18.8851C13.6157 19.0542 13.3832 19.107 13.2142 19.0013C13.0451 18.8957 12.9923 18.6632 13.098 18.4942C13.6791 17.5855 14.6722 17.0361 15.7499 17.0361C16.8382 17.0361 17.8314 17.5855 18.4125 18.5048C18.5181 18.6738 18.4653 18.9062 18.2963 19.0119C18.2329 19.033 18.1695 19.0542 18.0955 19.0542Z",
    fill: "#060000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59024 13.9244C9.45289 13.9244 9.31553 13.8399 9.25214 13.7025C9.16761 13.5123 9.25214 13.301 9.44232 13.2165C9.49515 13.1954 10.5834 12.7305 11.9992 12.8361C11.5449 12.2762 10.7102 11.5366 9.37893 11.3464C9.17818 11.3147 9.04083 11.1351 9.06196 10.9237C9.08309 10.7124 9.27327 10.5856 9.48458 10.6068C12.0626 10.9766 13.0558 13.0791 13.098 13.1742C13.1614 13.301 13.1403 13.4595 13.0452 13.5652C12.9501 13.6708 12.8128 13.7236 12.6754 13.6919C11.1011 13.301 9.75929 13.8821 9.73816 13.8927C9.69589 13.9138 9.64307 13.9244 9.59024 13.9244Z",
    fill: "#060000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8992 13.9244C21.8463 13.9244 21.8041 13.9139 21.7512 13.8927C21.7407 13.8822 20.3883 13.3116 18.814 13.692C18.6766 13.7237 18.5287 13.6814 18.4442 13.5652C18.3491 13.4595 18.3385 13.3011 18.3914 13.1743C18.4336 13.0898 19.4268 10.9766 22.0048 10.6068C22.2056 10.5751 22.3957 10.723 22.4274 10.9238C22.4591 11.1245 22.3112 11.3147 22.1105 11.3464C20.7898 11.5366 19.9551 12.2762 19.5008 12.8362C20.9166 12.72 21.9943 13.1848 22.0471 13.2165C22.2373 13.3011 22.3218 13.5124 22.2373 13.7026C22.1844 13.8505 22.0471 13.9244 21.8992 13.9244Z",
    fill: "#060000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_468_2660",
    x: 0.49834,
    y: 0,
    width: 31.0033,
    height: 30.0033,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.50166
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.25083
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_468_2660"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_468_2660",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngryFace);
export default __webpack_public_path__ + "static/media/angry-face.547099c1bfb9ec34bf08247d29549b77.svg";
export { ForwardRef as ReactComponent };